import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import useLang from '../../i18n/useLang';
import Nav from './Nav';
import Footer from './Footer';

const CONSENT_COOKIE = 'userConsent';

function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(Cookies.get(CONSENT_COOKIE) === undefined);
  }, []);

  const decide = (value) => {
    Cookies.set(CONSENT_COOKIE, value, { expires: 365, sameSite: 'Lax' });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookies"
      className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:bottom-5 sm:start-5 sm:max-w-sm"
    >
      <div className="rounded-3xl bg-white p-5 shadow-float ring-1 ring-fog-200">
        <p className="text-[0.95rem] leading-relaxed text-ink-600">{t('site.cookies.text')}</p>
        <div className="mt-4 flex gap-2">
          <button type="button" onClick={() => decide('true')} className="min-h-[44px] flex-1 rounded-lg bg-ink px-5 text-[0.95rem] font-medium text-white transition-colors hover:bg-navy-700">
            {t('site.cookies.accept')}
          </button>
          <button type="button" onClick={() => decide('false')} className="min-h-[44px] flex-1 rounded-lg px-5 text-[0.95rem] font-medium text-ink ring-1 ring-inset ring-fog-300 transition-colors hover:ring-ink-500">
            {t('site.cookies.reject')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Layout({ title, children }) {
  const { t } = useLang();
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title ? `${title} · Grovv` : 'Grovv · Process design and MES development with AI';
  }, [title]);

  useEffect(() => {
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = `https://www.grovv.co.il${pathname === '/' ? '/' : pathname}`;
  }, [pathname]);

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:start-3 focus:top-3 focus:z-[60] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-white"
      >
        {t('site.skip')}
      </a>
      <Nav />
      <main id="main" tabIndex={-1} key={pathname} className="page-in overflow-x-clip outline-none">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
